import { useEffect, useState } from "react";
import { Button, Modal, Row, Form } from "react-bootstrap";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import { RootState } from "redux/store";
import { Spinner } from "components";

type bulkEditProps = {
    show: boolean;
    handleClose: () => void;
    saveSelected: (newPriceGroupId: any) => void;
    count: number;
};

export function BulkEdit({ show, handleClose, saveSelected, count }: bulkEditProps) {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [disableSave, setDisableSave] = useState(false);
    const [disableClose, setDisableClose] = useState(false);
    const [newPriceGroupId, setNewPriceGroupId] = useState(0);
    const priceGroups = useAppSelector((state: RootState) => state.priceGroups);
    const assignPriceGroup = useAppSelector((state: RootState) => state.assignPriceGroup);

    useEffect(() => {
        if (!show) {
            setDisableSave(false);
            setDisableClose(false);
            setLoading(false);
            setNewPriceGroupId(0);
        }
    }, [show]);

    useEffect(() => {
        newPriceGroupId === 0 ? setDisableSave(true) : setDisableSave(false);
        loading ? setDisableSave(true) : setDisableSave(false);
    }, [newPriceGroupId, loading]);

    function save() {
        setDisableClose(true);
        setLoading(true);
        saveSelected(newPriceGroupId);
    }

    return (
        <Modal size="sm" className="modal-md" centered backdrop="static" show={show} onHide={handleClose}>
            <Modal.Header closeButton={!disableClose}>
                <Modal.Title>Bulk Edit - {count} Selected</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mt-3 mb-3 pe-0">
                    <Row className="ms-0 pb-3 pt-2">
                        <Form.Group>
                            <Form.Label className="mb-0">New Price Group</Form.Label>
                            <Form.Select
                                required
                                disabled={disableClose}
                                className="custom-select"
                                value={newPriceGroupId}
                                onChange={(e) => {
                                    setNewPriceGroupId(parseInt(e.target.value));
                                }}
                            >
                                <option disabled value="0">Select a new price group </option>
                                {priceGroups.table.map((priceLevel: any, index: any) => {
                                    return <option key={index} value={priceLevel.id}>{priceLevel.name}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Row>
                </Row>
                <Modal.Footer>
                    <Button disabled={disableClose} variant="secondary"className="cta-button" onClick={handleClose}
                    >Cancel</Button>
                    <Button disabled={disableSave} variant="primary" className="me-0 cta-button" onClick={save}>
                        {loading ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
                        {loading ? <>Saving...</> : <>Save</>}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
}